import Headline4 from './Headline4';
import Headline5 from './Headline5';
import BodySmall from './BodySmall';
import BodySmallSemibold from './BodySmallSemibold';
import BodyMedium from './BodyMedium';
import BodyMediumSemibold from './BodyMediumSemibold';
import BodyLarge from './BodyLarge';
import Head8 from './Head8';
import Head7 from './Head7';
import Head6 from './Head6';
import Head5 from './Head5';
import Head4 from './Head4';
import Head3 from './Head3';
import Head2 from './Head2';
import Head1 from './Head1';
import BodyLargeSemibold from './BodyLargeSemibold';
import BodyExtraLarge from './BodyExtraLarge';

const Text = {
  Headline4,
  Headline5,
  Head3,
  Head4,
  Head5,
  Head6,
  Head7,
  Head8,
  BodySmall,
  BodySmallSemibold,
  BodyMedium,
  BodyMediumSemibold,
  BodyLarge,
  Head2,
  BodyLargeSemibold,
  Head1,
  BodyExtraLarge,
};

export default Text;
